import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { Icon, Text } from '@/ui'
import { mtc, TextColors, TypographyStyles } from '@/styles'
import { TicketFiles } from './TicketFiles'

interface ReplySentProps {
  body?: string
  attachedFiles?: string[]
  droppedAttachments?: string[]
}

export const ReplySent = ({
  body,
  attachedFiles,
  droppedAttachments,
}: ReplySentProps) => (
  <div
    className={mtc(
      'my-2 rounded-2xl border border-green-50 bg-green-0',
      'px-4 py-4 flex flex-col gap-2'
    )}
  >
    <div className="flex items-center gap-2">
      <Icon
        icon={faCheck}
        color="text-green-100"
        className="text-base shrink-0"
      />
      <Text variant={TypographyStyles.LABEL_MD} color={TextColors.HIGHLIGHT}>
        Your reply was sent.
      </Text>
    </div>
    {body && (
      <Text
        variant={TypographyStyles.BODY_SM}
        color={TextColors.HIGHLIGHT}
        className="leading-relaxed"
      >
        &ldquo;{body}&rdquo;
      </Text>
    )}
    <TicketFiles
      attachedFiles={attachedFiles}
      droppedAttachments={droppedAttachments}
    />
  </div>
)
